// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertSettingsActions, globalActions } from "src/actions";

import { IProps } from "@blueprintjs/core";

import { ToggleButtons } from 'src/components';

import { MPDButton, MPDHiddenScrollContainer } from 'src/mpd-library';

import { SettingsSocialAccountListItem, SettingsSocialBanter } from '../components';

import "./styles.css";

interface ISocialSettingsProps extends IProps {
  accountType: string;
  routeProps: any;
  channels?: any;
  onUpdateToolBar: (
    topBarProps: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onAddAccount: (accountType: string) => (dispatch: Dispatch<any>) => Promise<void>;
  onAccountNameChange: (accountName: any, accountType: string, accountIndex: number) => (dispatch: Dispatch<any>) => Promise<void>;
  onAccountStatusChange: (accountStatus: any, accountType: string, accountId: string, history: any) => (dispatch: Dispatch<any>) => Promise<void>;
  onChannelStatusChange: (channelType: string) => (dispatch: Dispatch<any>) => Promise<void>;
  onCloseRightPanel?(): void;
  onToggleRightPanel?(): void;
}

class SocialSettings extends React.Component<ISocialSettingsProps> {
  constructor(props: ISocialSettingsProps) {
    super(props);
    this.updateToolBar = this.updateToolBar.bind(this);
    this.onAddAccount = this.onAddAccount.bind(this);
    this.onAccountNameChange = this.onAccountNameChange.bind(this);
    this.onAccountStatusChange = this.onAccountStatusChange.bind(this);
    this.onChannelStatusChange = this.onChannelStatusChange.bind(this);
    this.updateToolBar(this.props.accountType);
  }

  public componentWillReceiveProps(nextProps: ISocialSettingsProps) {
    if(nextProps.accountType !== this.props.accountType) {
      this.updateToolBar(nextProps.accountType);
    }
  }

  public render() {
    const { className, channels, accountType } = this.props;
    const social = channels[accountType]
    return (
      <div className={classNames('social-settings-container', className)}>
        <div>
          <SettingsSocialBanter
            imageName={'compose-alert--channels--' + [accountType] + '-active'}
            title={accountType.charAt(0).toUpperCase() + accountType.slice(1)}
            active={social.status}
            subtitle={'Automatically post alerts to your ' + [accountType] + ' account'}
            actionButtonText={'Install ' + accountType}
            actionButtonTextActive='Installed'
            actionButtonClick={this.onChannelStatusChange}
          />
        </div>
        <MPDHiddenScrollContainer yDirection={true} className='social-settings-accounts-wrapper'>
          <div>
          {social && 
            social.list.map((account: any, index: number) => (
              <SettingsSocialAccountListItem
                active={account.active}
                key={index}
                name={!account.name.includes('@') ? '@' + account.name : account.name}
                status={account.active ? 'Active Since ' + account.date : 'Deactive'}
                statusOptions={['edit', 'delete', 'deactivate']}
                titleChanged={e => this.onAccountNameChange(e, index)}
                statusChanged={e => this.onAccountStatusChange(e, account.id)}
              />
            ))
          }
          <MPDButton className={'social-settings-accounts-action'} text='+ Add Another Account' onClick={this.onAddAccount} />
          </div>
        </MPDHiddenScrollContainer>
      </div>
    );
  }

  private onChannelStatusChange(event: any) {
    const { accountType } = this.props;
    this.props.onChannelStatusChange(accountType);
  }

  private onAccountStatusChange(event: any, accountId: string) {
    const { accountType, routeProps } = this.props;
    const history = routeProps.history;
    const status = event.currentTarget.textContent;
    this.props.onAccountStatusChange(status, accountType, accountId, history);
  }

  private onAccountNameChange(event: any, index: number) {
    const { accountType } = this.props;
    const accountName = event.currentTarget.value;
    this.props.onAccountNameChange(accountName, accountType, index);
  }  

  private onAddAccount() {
    const { accountType } = this.props;
    this.props.onAddAccount(accountType);
  }

  private updateToolBar(text: string) {
    const topBarProps = {
      leftElement: (
        <ToggleButtons
          label={text.charAt(0).toUpperCase() + text.slice(1)}
          onToggle={this.props.onToggleRightPanel}
          onClose={this.props.onCloseRightPanel}
        />
      ),
    };
    if(this.props.onUpdateToolBar){
      this.props.onUpdateToolBar(topBarProps);
    }
  }
}


const mapStateToProps = (state: any) => {
  const {  alertSettings } = state;
  const { channels } = alertSettings;

  return {
    channels
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onUpdateToolBar: bindActionCreators(
      globalActions.onUpdateToolBar,
      dispatch
    ),
    onAddAccount: bindActionCreators(
      alertSettingsActions.onAddChannelItem,
      dispatch
    ),
    onAccountNameChange: bindActionCreators(
      alertSettingsActions.onChangeChannelAccountName,
      dispatch
    ),
    onAccountStatusChange: bindActionCreators(
      alertSettingsActions.onChangeChannelAccountStatus,
      dispatch
    ),
    onChannelStatusChange: bindActionCreators(
      alertSettingsActions.onChangeChannelStatus,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SocialSettings);



// WEBPACK FOOTER //
// ./src/controllers/alert-settings/social-settings/social-settings.tsx